import React from 'react';
import PropTypes from 'prop-types';

import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Table,
  TableBody,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import AddressDetailBox from 'src/components/AddressDetailBox/AddressDetailBox';
import useStyles from '../styles';

const EquipmentAddressDetail = ({ contract }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Card variant="elevation">
      <CardHeader
        className={classes.header}
        title={
          <Typography className={classes.tableCell} component="h4" variant="h4">
            {t('CONTRACT_VIEW.CONTRACT_DETAIL.EQUIPMENT_ADDRESS')}
          </Typography>
        }
      />
      <Divider className={classes.tableCell} />
      <CardContent style={{ padding: 0, marginBottom: '16px' }}>
        <Table>
          <TableBody>
            <AddressDetailBox
              address={
                contract.equipmentLocation ? contract.equipmentLocation : {}
              }
            />
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

EquipmentAddressDetail.propTypes = {
  contract: PropTypes.object.isRequired
};

export default EquipmentAddressDetail;
